import { render, staticRenderFns } from "./pill_display.vue?vue&type=template&id=59fd2ea2&"
import script from "./pill_display.vue?vue&type=script&lang=js&"
export * from "./pill_display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59fd2ea2')) {
      api.createRecord('59fd2ea2', component.options)
    } else {
      api.reload('59fd2ea2', component.options)
    }
    module.hot.accept("./pill_display.vue?vue&type=template&id=59fd2ea2&", function () {
      api.rerender('59fd2ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/pill_display.vue"
export default component.exports